<ng-content select="ion-icon, eva-icon"></ng-content>
<ng-content select="h2, header"></ng-content>
<ng-content select="p"></ng-content>
